/**
 * @generated SignedSource<<9ef6afdadb31a5d8937ac70bb682f8d0>>
 * @relayHash 8c9084e93a5e559b96f2efb00da0cb4e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 01ed243a7e68d2de39a092502b0706ce640250e648161d3c80d535b0a8b8b012

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type IssueRealtimeUpdates_issueUpdatedSubscription$variables = {
  cloudId: string;
  projectIds?: ReadonlyArray<string> | null | undefined;
};
export type IssueRealtimeUpdates_issueUpdatedSubscription$data = {
  readonly jira: {
    readonly onIssueUpdatedByProjectsNoEnrichment: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type IssueRealtimeUpdates_issueUpdatedSubscription = {
  response: IssueRealtimeUpdates_issueUpdatedSubscription$data;
  variables: IssueRealtimeUpdates_issueUpdatedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIds"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectIds",
            "variableName": "projectIds"
          }
        ],
        "concreteType": "JiraIssueUpdatedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueUpdatedByProjectsNoEnrichment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "IssueRealtimeUpdates_issueUpdatedSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IssueRealtimeUpdates_issueUpdatedSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "01ed243a7e68d2de39a092502b0706ce640250e648161d3c80d535b0a8b8b012",
    "metadata": {},
    "name": "IssueRealtimeUpdates_issueUpdatedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "a0472302cd79ec86834d4c2547eb2127";

export default node;
